import Vue from 'vue'
import Vuex from 'vuex'
import { omit } from 'lodash'

import quotation from './quotation'
import travelSetup from './travelSetup'
import user from './user'
import payment from './payment'
import additional from './additional'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    quotation,
    travelSetup,
    user,
    payment,
    additional
  }
})

store.subscribe((mutation, state) => {
  const omited = omit(state, [])
  window.sessionStorage.setItem('ciclic:travel', JSON.stringify(omited))
})

export default store
